import { render } from "./StartSection.vue?vue&type=template&id=651ca320&scoped=true"
const script = {}

import "./StartSection.vue?vue&type=style&index=0&id=651ca320&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651ca320"]])

export default __exports__